import { render, staticRenderFns } from "./levelinfo.vue?vue&type=template&id=074de24e&scoped=true&"
import script from "./levelinfo.vue?vue&type=script&lang=js&"
export * from "./levelinfo.vue?vue&type=script&lang=js&"
import style0 from "./levelinfo.vue?vue&type=style&index=0&id=074de24e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074de24e",
  null
  
)

export default component.exports